import { render } from "./WorkerView.vue?vue&type=template&id=47fce7b5&scoped=true"
import script from "./WorkerView.vue?vue&type=script&lang=js"
export * from "./WorkerView.vue?vue&type=script&lang=js"

import "./WorkerView.vue?vue&type=style&index=0&id=47fce7b5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fce7b5"]])

export default __exports__